// const IOS_FEES = 0.3;

export function getIosPrice(price) {
  if (!price || isNaN(price)) {
    return 0;
  }
  if (typeof price === 'string') {
    price = parseFloat(price);
  }
  // const iosFees = price * IOS_FEES;
  // const total = price + iosFees;
  return price.toFixed(2);
}
